import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type UserAnalytics = {
  totalResumes: number;
  totalViews: number;
  totalDownloads: number;
  sources: Record<string, number>;
  geography: Record<string, number>;
  topResume?: {
    id: string;
    title: string;
    slug: string;
  };
}

export const fetchUserAnalytics = async () => {
  const { data } = await axios.get<UserAnalytics>("/analytics/user");
  return data;
};

export const useUserAnalytics = () => {
  const {
    error,
    isPending: loading,
    data: analytics,
  } = useQuery({
    queryKey: ["analytics", "user"],
    queryFn: fetchUserAnalytics,
  });

  return { analytics, loading, error };
};
